import script from "./UsersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersTable.vue?vue&type=script&setup=true&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=4a531e42&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a531e42"]])

export default __exports__